import { ClipSuggestion } from './types';
import { createClipName, CreateClipNameOptions } from './utils';

export const clipSuggestionNameSelector = (
  updatedSuggestionProjectName?: string,
  suggestion?: ClipSuggestion,
  suggestionIds?: number[],
  opts?: CreateClipNameOptions<'string'>,
) => {
  if (!suggestion) {
    return undefined;
  }

  if (updatedSuggestionProjectName) {
    return updatedSuggestionProjectName;
  }

  const {
    id,
    isProjectNameEdited,
    projectName,
    startMillis,
    endMillis,
  } = suggestion;

  const suggestionIndex = suggestionIds.indexOf(id);

  return isProjectNameEdited
    ? projectName
    : createClipName(suggestionIndex, startMillis, endMillis, opts);
};

export const isSuggestionUnresolvedSelector = (suggestion?: ClipSuggestion) =>
  suggestion?.status !== 'completed' && suggestion?.status !== 'failed';

export const isGeneratingPreviewSelector = (suggestion: ClipSuggestion) =>
  isSuggestionUnresolvedSelector(suggestion) && suggestion?.isPreviewRequested;
